import { useMutation } from '@tanstack/react-query';
import { errorHandler } from '@app/utils/errorHandler';
import { ISelectOption } from '@widgets/multi-select';

export const fetch = async (): Promise<ISelectOption[]> => {
  return [
    { value: 'Категория 1', label: 'Категория 1' },
    { value: 'Категория 2', label: 'Категория 2' },
  ];
};

export const useClientCategoryOptions = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: fetch,
    onError: error => errorHandler(error),
  });

  return {
    fetch: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};
